import { useSettings } from '../contexts/SettingsContext';
import type { ThemeName } from '../themes/tokens';

const themeColors = {
  light: {
    title: '#111827',
    description: '#6B7280',
    text: '#374151',
    cardBackground: 'rgba(255, 255, 255, 1)',
    menuText: '#111827',
    menuTextHover: '#374151',
    menuBackground: 'rgba(255, 255, 255, 1)',
    menuBackgroundHover: 'rgba(243, 244, 246, 1)',
    actionIcon: '#6B7280',
    actionIconHover: '#374151',
    divider: 'rgba(0, 0, 0, 1)',
    codeText: '#374151',
    background: '#F3F4F6',
    backgroundTransparent: 'rgba(255, 255, 255, 1)',
    border: '#E5E7EB',
    accent: '#4F46E5',
    accentHover: '#4338CA',
  },
  dark: {
    title: '#F9FAFB',
    description: '#9CA3AF',
    text: '#F3F4F6',
    cardBackground: 'rgba(31, 41, 55, 1)',
    menuText: '#F9FAFB',
    menuTextHover: '#F3F4F6',
    menuBackground: 'rgba(24, 24, 27, 1)',
    menuBackgroundHover: 'rgba(39, 39, 42, 1)',
    actionIcon: '#9CA3AF',
    actionIconHover: '#F3F4F6',
    divider: 'rgba(255, 255, 255, 1)',
    codeText: '#F3F4F6',
    background: '#111827',
    backgroundTransparent: 'rgba(17, 24, 39, 1)',
    border: '#374151',
    accent: '#6366F1',
    accentHover: '#4F46E5',
  },
  spotify: {
    title: '#FFFFFF',
    description: '#B3B3B3',
    text: '#FFFFFF',
    cardBackground: 'rgba(40, 40, 40, 1)',
    menuText: '#FFFFFF',
    menuTextHover: '#E4E4E4',
    menuBackground: 'rgba(40, 40, 40, 1)',
    menuBackgroundHover: 'rgba(24, 24, 24, 1)',
    actionIcon: '#B3B3B3',
    actionIconHover: '#FFFFFF',
    divider: 'rgba(255, 255, 255, 1)',
    codeText: '#FFFFFF',
    background: '#282828',
    backgroundTransparent: 'rgba(40, 40, 40, 1)',
    border: '#181818',
    accent: '#1DB954',
    accentHover: '#1ed760',
  },
} as const;

type ColorType = keyof typeof themeColors.light;

export function useDirectTheme() {
  const { currentTheme } = useSettings();
  const theme = currentTheme as ThemeName;

  const getDirectColor = (type: ColorType) => {
    return themeColors[theme][type];
  };

  return {
    getDirectColor,
  };
}
